module.exports = __webpack_public_path__ + "media/Indian Tea.ac0699bc.mp4";